<template>
	<div class="p_box" id="box">
		<div id="head">
			<el-breadcrumb separator="/">
				<el-breadcrumb-item :to="{ path: '/Homet' }">首页</el-breadcrumb-item>
				<el-breadcrumb-item :to="{ path: '/Mine' }">我的题库</el-breadcrumb-item>
				<el-breadcrumb-item>{{ type == 1 ? '修改习题册' : '新建习题册' }}</el-breadcrumb-item>
			</el-breadcrumb>
			<div class="p_m_t_20">
				<div class="header_box p_flex">
					<div class="p_flex p_login p_f_a">
						<span class="p_m_l_30 type_size_18 ">名称</span>
						<div class="p_f_1 p_m_l_30 type_size_18  p_m_r_30"><el-input type="text" v-model="name" placeholder="请输入名称"></el-input></div>
					</div>
					<div class="p_login p_flex p_f_a p_m_l_30">
						<span class="p_m_l_20 type_size_18">年级</span>
						<div class="p_f_1 p_m_l_20 p_m_r_20">
							<el-select class="p_flex" v-model="gradeTypes" placeholder="请选择" @change="goGradeTypes">
								<el-option v-for="item in gradeLists" :disabled="disab" :key="item.id" :label="item.name" :value="item.id"></el-option>
							</el-select>
						</div>
					</div>
					<div class="p_login p_flex p_f_a p_m_l_30">
						<span class="p_m_l_20 type_size_18">学科</span>
						<div class="p_f_1 p_m_l_20 p_m_r_20">
							<el-select class="p_flex" v-model="subjectTypes" placeholder="请选择" @change="goSubjectTypes">
								<el-option v-for="item in subjectLists" :disabled="disab" :key="item.id" :label="item.name" :value="item.id"></el-option>
							</el-select>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="content_box p_m_t_20 overflow" :style="{ height: height + 'px' }">
			<div style="height: 80%;"><view-list ref="viewlist" :dataInfo="dataInfo" @godelete="godelete" :ids="ids"></view-list></div>
			<div class="p_flex p_f_c btn_box">
				<el-button type="info" icon="el-icon-circle-plus-outline" @click="goAdd(2)">从我的题库添加题目</el-button>
				<el-button type="info" icon="el-icon-circle-plus-outline" @click="goAdd(1)">从校本题库添加题目</el-button>
			</div>
			<div class="btn p_flex p_f_c p_m_t_20" v-if="ids.length != 0">
				<el-button type="success" style="color: #FFFFFF;" @click="BaoCun">{{ id == '' ? '保存' : '修改' }}</el-button>
				<!-- <el-button type="warning" >下发</el-button> -->
			</div>
		</div>
	</div>
</template>

<script>
import ViewList from './commponents/listone.vue';
export default {
	name: 'NewExercises',
	components: {
		ViewList
	},
	data() {
		return {
			height: 0,
			type: 0,
			gradeLists: [],
			subjectLists: [],
			gradeTypes: '',
			subjectTypes: '',
			name: '',
			disab: false,
			gradeId: '',
			subjectId: '',
			dataInfo: {},
			ids: [],
			id: ''
		};
	},
	watch: {
		'$route.path': {
			immediate: true,
			handler(newVal, oldVal) {
				if (newVal == '/NewExercises') {
					var height = localStorage.getItem('height');
					if (height == '') {
					} else {
						this.height = height;
					}
				}
			}
		}
	},
	created() {
		this.$request
			.ajax(this)
			.post('/Library/grade')
			.then(res => {
				//年纪
				// console.log(res)
				this.gradeLists = res.data;
			});
		this.$request
			.ajax(this)
			.post('/Library/subject')
			.then(res => {
				// console.log(res)
				this.subjectLists = res.data;
			});
		if (this.$route.query.info) {
			console.log(JSON.parse(this.$route.query.info));
			var data = JSON.parse(this.$route.query.info);
			var ojbk = data.question_ids.split('|');
			var newArr = [];
			for (var i = 0; i < ojbk.length; i++) {
				newArr.push(Number(ojbk[i]));
			}
			this.ids = newArr;
			this.name = data.name;
			this.disab = true;
			this.gradeId = data.grade;
			this.subjectId = data.subject;
			this.id = data.id;
			this.type = 1;
			setTimeout(() => {
				for (var i = 0; i < this.gradeLists.length; i++) {
					if (data.grade == this.gradeLists[i].id) {
						this.gradeTypes = this.gradeLists[i].name;
					}
				}
				for (var i = 0; i < this.subjectLists.length; i++) {
					if (data.subject == this.subjectLists[i].id) {
						this.subjectTypes = this.subjectLists[i].name;
					}
				}
			}, 1000);
		}
		if (this.$route.query.Info) {
			var data = JSON.parse(this.$route.query.Info);
			this.dataInfo = data;
			this.name = data.name;
			this.gradeId = data.gradeTypes;
			this.subjectId = data.subjectTypes;
			this.id = data.id;
			if (this.$route.query.ids) {
				this.ids = JSON.parse(this.$route.query.ids);
				console.log(this.ids);
			}
			setTimeout(() => {
				for (var i = 0; i < this.gradeLists.length; i++) {
					if (data.gradeTypes == this.gradeLists[i].id) {
						this.gradeTypes = this.gradeLists[i].name;
					}
				}
				for (var i = 0; i < this.subjectLists.length; i++) {
					if (data.subjectTypes == this.subjectLists[i].id) {
						this.subjectTypes = this.subjectLists[i].name;
					}
				}
			}, 1000);
		}
	},
	mounted() {
		this.indexInfo();
	},
	methods: {
		indexInfo() {
			var box = document.getElementById('box').offsetHeight;
			var head = document.getElementById('head').offsetHeight;
			var height = box - head - 20;
			var heights = localStorage.getItem('height');
			if (heights == null) {
				localStorage.setItem('height', height);
			} else {
			}
			this.height = height;
		},
		goAdd(i) {
			if (this.gradeTypes == '') {
				this.$message.error('请选择');
				return;
			}
			if (this.subjectTypes == '') {
				this.$message.error('请选择');
				return;
			}

			this.$router.push({
				path: '/NewAdd',
				query: {
					name: this.name,
					gradeTypes: this.gradeId,
					subjectTypes: this.subjectId,
					belonging: i,
					ids: JSON.stringify(this.ids),
					id: this.id
				}
			});
		},
		goGradeTypes(e) {
			this.gradeId = e;
		},
		goSubjectTypes(e) {
			this.subjectId = e;
		},
		// 删除
		godelete(val) {
			for (var i = 0; i < this.ids.length; i++) {
				if (val == this.ids[i]) {
					this.ids.splice(i, 1);
					// this.BaoCun();
					this.$refs.viewlist.getPag()
				}
			}
			console.log(val);
		},
		BaoCun() {
			if (this.name == '') {
				this.$message.error('名称不能为空！');
				return;
			}
			if (this.id != '') {
				this.$request
					.ajax(this)
					.post('/api_teacher/exercise_book_edit/' + this.id, {
						name: this.name,
						question_ids: this.ids /* 题目ID */
					})
					.then(res => {
						// console.log(res)
						this.$router.push('/Mine');
					});
				return;
			}
			this.$request
				.ajax(this)
				.post('/api_teacher/exercise_book_create', {
					name: this.name,
					grade: this.gradeId, // 年级
					subject: this.subjectId, // 学科
					question_ids: this.ids /* 题目ID */
				})
				.then(res => {
					// console.log(res)
					if (res.data.id) {
						this.$message({
							message: '新建成功!',
							type: 'success'
						});
						this.$router.push('/Mine');
					}
				});
		}
	},

	beforeRouteLeave(to, form, next) {
		localStorage.removeItem('height');
		next();
	}
};
</script>

<style lang="scss" scoped>
.content_box {
	background: #ffffff;
}
.header_box {
	padding: 20px 60px;
	background-color: #ffffff;
}
>>> .el-input__inner {
	border: none;
	background-color: #f5f5f5;
	font-size: 18px;
	color: #333;
	padding: 0;
}

>>> input::-webkit-input-placeholder {
	font-size: 18px;
}
.p_login {
	flex: 1;
}
>>> .el-button {
	font-size: 20px;
	color: #00af63;
}
>>> .el-button--info {
	background-color: #f5f5f5;
	border-color: #f5f5f5;
}
.btn_box {
	padding: 30px 0 0;
}
</style>



// WEBPACK FOOTER //
// src/components/homet/exercises/index.vue